import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '../lib/analytics'

export default function AnalyticsPageView() {
  const location = useLocation()

  useEffect(() => {
    // Let the route SEO effect update document.title before recording the view.
    const timer = window.setTimeout(() => {
      trackEvent('page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: `${location.pathname}${location.search}`,
      })
    }, 0)

    return () => window.clearTimeout(timer)
  }, [location.pathname, location.search])

  return null
}
